import React, { useCallback, useEffect, useState } from "react";
import { Button, Input, Select, Tooltip } from "antd";
import { httpService } from "../../../../../services/httpService.service";
import SearchIcon from "./../../../../../Assets/svg/searchIcon.svg";
import debounce from "lodash/debounce";
import { siteVisitStatusEnum } from "../../../../../services/Enums/siteVisitStatusEnum";
import { months, years } from "../../../../../services/Enums/monthsAndYears";
import { InfoCircleOutlined } from "@ant-design/icons";
import { sample, sampleSize, set } from "lodash";

const { Option } = Select;

const Filters = ({ filters, setFilters, setPagination }) => {
  const [showFilters, setShowFilters] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [sampleSizes, setSampleSizes] = useState([]);
  const [implementingPartners, setImplementingPartners] = useState([]);
  const [clusters, setClusters] = useState([]);
  const [filtersValue, setFiltersValue] = useState({
    ImplementingPartnerId: [],
    State: [],
    SiteVisitStatus: [],
    FieldTeamReportingStatus: "",
    ClusterId: [],
    Month: [],
    Year: [],
    DataCheckIds: [],
    Search: "",
    Governates: [],
    Cities: [],
  });

  const debouncedHandler = useCallback(
    debounce((filter) => {
      setFilters((prevFilters) => ({
        ...prevFilters,
        ...filter,
      }));
      setPagination((prevPagination) => ({ ...prevPagination, current: 1 }));
    }, 1000),
    []
  );

  useEffect(() => {
    httpService.get(
      `/api/Site/getCountriesOfSiteVisits`,
      (res) => {
        const data = res.data;
        const formattedData = Array.from(
          new Set(
            data
              .map((country) => country.trim())
              .filter(
                (country) =>
                  country &&
                  country.toLowerCase() !== "string" &&
                  country.toLowerCase() !== "undefined"
              )
          )
        )
          .sort((a, b) => a.localeCompare(b))
          .map((stateName, index) => ({
            id: index,
            stateName,
          }));

        setCountries(formattedData);
      },
      (error) => {
        // console.log(error);
      }
    );

    httpService.get(
      `/api/Site/getStatesOfSiteVisits`,
      (res) => {
        const data = res.data;
        const formatedData = data
          .filter(
            (state) => state.trim() != "string" && state.trim() != "undefined"
          )
          .map((state, index) => ({
            id: index,
            stateName: state.trim(),
          }));
        setStates(formatedData);
      },
      (error) => {
        // console.log(error);
      }
    );

    httpService.get(
      `/api/Site/getCitiesOfSiteVisits`,
      (res) => {
        const data = res.data;
        const formatedData = data
          .filter(
            (city) => city.trim() != "string" && city.trim() != "undefined"
          )
          .map((city, index) => ({
            id: index,
            name: city.trim(),
          }));
        setCities(formatedData);
      },
      (error) => {
        // console.log(error);
      }
    );

    const workspaceId = localStorage.getItem("currentContractId");
    const apiIps = `/api/ImplementingPartner/getAllImplementingPartners?contractId=${workspaceId}&IgnorePagination=true`;

    httpService.get(
      apiIps,
      (res) => setImplementingPartners(res.data),
      (error) => {
        // console.log(error)
      }
    );

    const apiClusters = "/api/Site/getAllClusters";
    httpService.get(
      apiClusters,
      (res) => setClusters(res.data),
      (error) => {
        // console.log(error)
      }
    );

    const apiSampleSizes = `/api/Datachecks/getAll?projectId=${localStorage.getItem("currentProjectID")}`;
    httpService.get(
      apiSampleSizes,(res) => {setSampleSizes(res.data);},
      (error) => {
        // console.log(error)
      }
    );
  }, []);

  const handleToggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const handleSearch = (event) => {
    const search = event?.target.value.toLowerCase();
    setFiltersValue((prevFiltersValue) => ({
      ...prevFiltersValue,
      Search: search,
    }));
    debouncedHandler({ Search: search });
  };

  const handleCountryChange = (State) => {
    setFiltersValue((prevFiltersValue) => ({
      ...prevFiltersValue,
      State,
    }));
    debouncedHandler({ State: State });
  };

  const handleStateChange = (Governates) => {
    setFiltersValue((prevFiltersValue) => ({
      ...prevFiltersValue,
      Governates,
    }));
    debouncedHandler({ Governates: Governates });
  };

  const handleCityChange = (Cities) => {
    setFiltersValue((prevFiltersValue) => ({
      ...prevFiltersValue,
      Cities,
    }));
    debouncedHandler({ Cities: Cities });
  };

  const handleClearAll = () => {
    setFilters({
      ImplementingPartnerId: [],
      State: [],
      SiteVisitStatus: [],
      FieldTeamReportingStatus: "",
      ClusterId: [],
      Month: [],
      Year: [],
      Search: "",
      Governates: [],
      Cities: [],
      DataChecksId: [],
    });
    setFiltersValue({
      ImplementingPartnerId: [],
      State: [],
      SiteVisitStatus: [],
      FieldTeamReportingStatus: "",
      ClusterId: [],
      Month: [],
      Year: [],
      Search: "",
      Governates: [],
      Cities: [],
      DataChecksId: [],
    });
    setCities([]);
    setStates([]);
    setPagination((prevPagination) => ({ ...prevPagination, current: 1 }));
  };

 const handleSampleSizeChange = (sampleSize) => {
    debouncedHandler({ DataChecksId: sampleSize });
    setFiltersValue((prevFiltersValue) => ({
      ...prevFiltersValue,
      DataChecksId: sampleSize,
    }));
  };

  const handleMonthChange = (month) => {
    debouncedHandler({ Month: month });
    setFiltersValue((prevFiltersValue) => ({
      ...prevFiltersValue,
      Month: month,
    }));
  };

  const handleYearChange = (year) => {
    debouncedHandler({ Year: year });
    setFiltersValue((prevFiltersValue) => ({
      ...prevFiltersValue,
      Year: year,
    }));
  };

  const handleIpChange = (ImplementingPartnerId) => {
    debouncedHandler({ ImplementingPartnerId: ImplementingPartnerId });
    setFiltersValue((prevFiltersValue) => ({
      ...prevFiltersValue,
      ImplementingPartnerId,
    }));
  };

  return (
    <div className="filtersWrapper">
      <div className="containerFilters">
        <Input
          placeholder="Type something here"
          suffix={<img src={SearchIcon} alt="Search" />}
          onChange={handleSearch}
          value={filtersValue?.Search || undefined}
        />
        <Button className="clearButton" onClick={handleClearAll}>
          Clear All
        </Button>
        <Button onClick={handleToggleFilters} className="toggleButton">
          {showFilters ? "Hide Filters" : "Show Filters"}
        </Button>
      </div>
      {showFilters && (
        <div className="filtersContainer">
          <div className="filter">
            <p className="filterText">Implementing Partner</p>
            <Select
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select the IP"
              allowClear
              value={filtersValue.ImplementingPartnerId}
              showSearch
              onChange={handleIpChange}
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {implementingPartners &&
                implementingPartners.map((implementingPartner) => (
                  <Option
                    key={implementingPartner.id}
                    value={implementingPartner.id}
                  >
                    {implementingPartner.name}
                  </Option>
                ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">Site Visit Status</p>
            <Select
              value={filtersValue.SiteVisitStatus}
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select a site visit status"
              allowClear
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
              onChange={(value) => {
                debouncedHandler({ SiteVisitStatus: value });
                setFiltersValue((prevFiltersValue) => ({
                  ...prevFiltersValue,
                  SiteVisitStatus: value,
                }));
              }}
            >
              {Object.entries(siteVisitStatusEnum)
                .filter(([key]) => key !== "default")
                .map(([key, value]) => (
                  <Option value={Number(key)}>{value.text}</Option>
                ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">Cluster</p>
            <Select
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select the Cluster"
              allowClear
              showSearch
              value={filtersValue.ClusterId}
              onChange={(value) => {
                debouncedHandler({ ClusterId: value });
                setFiltersValue((prevFiltersValue) => ({
                  ...prevFiltersValue,
                  ClusterId: value,
                }));
              }}
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {clusters &&
                clusters.map((cluster) => (
                  <Option key={cluster.id} value={cluster.id}>
                    {cluster.name}
                  </Option>
                ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">Month</p>
            <Select
              showSearch
              allowClear
              mode="multiple"
              onChange={handleMonthChange}
              value={filtersValue.Month || undefined}
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select a month"
            >
              {Object.entries(months).map(([key, value]) => (
                <Option key={key} value={key}>
                  {value}
                </Option>
              ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">Year</p>
            <Select
              showSearch
              mode="multiple"
              allowClear
              onChange={handleYearChange}
              value={filtersValue.Year || undefined}
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select a year"
            >
              {years &&
                years.map((year, index) => (
                  <Option key={index} value={year}>
                    {year}
                  </Option>
                ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">
              <Tooltip title="Countries not listed here have no scheduled site visits.">
                <InfoCircleOutlined
                  style={{ marginRight: 5, color: "#1890ff" }}
                />
              </Tooltip>
              Country
            </p>
            <Select
              onChange={handleCountryChange}
              value={filtersValue.State ? filtersValue.State : undefined}
              allowClear
              showSearch
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select Country"
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {countries &&
                countries.map((country) => (
                  <Option key={country.id} value={country.stateName}>
                    {country.stateName}
                  </Option>
                ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">
              <Tooltip title="States not listed here have no scheduled site visits.">
                <InfoCircleOutlined
                  style={{ marginRight: 5, color: "#1890ff" }}
                />
              </Tooltip>
              Governorate/State
            </p>
            <Select
              onChange={handleStateChange}
              value={
                filtersValue.Governates ? filtersValue.Governates : undefined
              }
              allowClear
              showSearch
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select Country"
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {states.map((state) => (
                <Option key={state.id} value={state.stateName}>
                  {state.stateName}
                </Option>
              ))}
            </Select>
          </div>
          <div className="filter">
            <p className="filterText">
              <Tooltip title="Cities not listed here have no scheduled site visits.">
                <InfoCircleOutlined
                  style={{ marginRight: 5, color: "#1890ff" }}
                />
              </Tooltip>
              City
            </p>
            <Select
              onChange={handleCityChange}
              value={filtersValue.Cities ? filtersValue.Cities : undefined}
              allowClear
              showSearch
              mode="multiple"
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select Country"
              filterOption={(input, option) =>
                option.children.toLowerCase().startsWith(input.toLowerCase())
              }
            >
              {cities.map((city) => (
                <Option key={city.id} value={city.name}>
                  {city.name}
                </Option>
              ))}
            </Select>
          </div>
        <div className="filter">
            <p className="filterText">Additional Tools</p>
            <Select
              showSearch
              mode="multiple"
              allowClear
              onChange={handleSampleSizeChange}
              value={filtersValue.DataChecksId || undefined}
              style={{ width: 200, marginBottom: 20 }}
              placeholder="Select a sample size"
            >
              {sampleSizes &&
                sampleSizes.map((sampleSizes, index) => (
                  <Option key={index} value={sampleSizes.id}>
                    {sampleSizes.name}
                  </Option>
                ))}
            </Select>
          </div>
        </div>
      )}
    </div>
  );
};

export default Filters;
